import React, {useCallback, useMemo, useState} from 'react';
import classes from './style.module.scss';
import {Archive} from "~/types";
import classNames from "classnames";
import Icon from "~/app/common/Icon";
import FileIcon from "./FileIcon";
import ExternalLink from "~/app/common/ExternalLink";
import {useStoreActions, useStoreState} from "~/store";
import Loader from "~/app/common/Loader";

export interface ListItemProps {
    item: Archive
    machineId: string
}

export type ListItemComponent = React.FC<ListItemProps>

const ListItem: ListItemComponent = ({item, machineId}) => {
    const setParentFolderIdAction = useStoreActions(actions => actions.documentation.setParentFolderId);
    const openArchiveFileAction = useStoreActions(actions => actions.documentation.openArchiveFile);
    const downloadProgress = useStoreState(state => state.documentation.downloadProgress[item.id]);

    const isFileDownloaded = useMemo(() => downloadProgress === 100, [downloadProgress]);
    const [externalUrl, setExternalUrl] = useState('');
    const linkUrl = [item.filePath, item.description, item.name]
        .find(value => value && /^(https?:\/\/|www\.)/i.test(value.trim())) || '';
    const isLink = item.fileType === 'link' || (item.type === 1 && !item.fileName && !!linkUrl);

    const clickHandler = useCallback(() => {
        if (isLink && linkUrl) {
            if (window['cordova']?.InAppBrowser) {
                setExternalUrl(linkUrl);
            } else {
                window.open(linkUrl, '_blank', 'noopener,noreferrer');
            }
            return;
        }
        if (item.type === 1 && item.downloadLink !== '' && (downloadProgress === undefined || isFileDownloaded)) {
            openArchiveFileAction({archive: item, machineId});
        } else if (item.type === 0) {
            setParentFolderIdAction(item.id);
        }
    }, [item, isLink, linkUrl, setParentFolderIdAction, openArchiveFileAction, downloadProgress, isFileDownloaded, machineId]);

    return (
        <>
            <div className={classes['list-item']} onClick={clickHandler}>
                {isLink
                    ? <div className={classes['link-icon-wrap']}><Icon name="link" size="32"/></div>
                    : <FileIcon extension={item.fileType}/>
                }
                <div className={classes['info']}>
                    <div className={classes['name']}>
                        {/^(https?:\/\/|www\.)/i.test(item.name || '') ? 'Link' : item.name}
                    </div>
                    {!isLink && item.description && <div className={classes['description']}>{item.description}</div>}
                </div>
                {!item.type && <div className={classNames(classes['right-icon-wrap'])}>
                    <Icon name="keyboard_arrow_right"/>
                </div>}
                {(!!item.type && !isLink && !isFileDownloaded) && <div className={classNames(classes['right-icon-wrap'])}>
                    {downloadProgress === undefined ? <Icon name="get_app"/> : <Loader inline percentage={downloadProgress !== -1 ? downloadProgress : undefined}/>}
                </div>}
                {isLink && <div className={classNames(classes['right-icon-wrap'])}>
                    <Icon name="launch"/>
                </div>}
            </div>
            <ExternalLink open={!!externalUrl} url={externalUrl} onClose={() => setExternalUrl('')}/>
        </>
    );
};

export default ListItem
